<template>
  <div v-if="visible" class="portal-institutional-footer-wrap">
    <v-divider></v-divider>
    <footer
      class="portal-institutional-footer pt-2 pb-0 px-4 text-body-2 text-medium-emphasis"
      v-html="hospitalConfig.htmlFooter"
    />
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PortalInstitutionalFooter',
  computed: {
    ...mapState('portalConfig', ['hospitalConfig']),
    visible() {
      const html = String(this.hospitalConfig.htmlFooter || '').trim()
      return this.$route.meta.showInstitutionalFooter === true && html !== ''
    },
  },
}
</script>

<style scoped>
.portal-institutional-footer-wrap,
.portal-institutional-footer {
  background: rgb(var(--v-theme-background));
}
.portal-institutional-footer :deep(table) {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.portal-institutional-footer :deep(a) {
  color: rgb(var(--v-theme-primary));
}
</style>
